import React, { FC } from 'react';

import styled from 'styled-components';

import { RawPicture } from 'components/raw-picture';
import { INavigationTabFragment } from 'generated/sanity-graphql';
import { routes } from 'utils/routing';

import { NavLink } from './helpers';
import { IconWrap, NavLinkText } from './styled';

const IconWrapBase = styled(IconWrap)`
  position: relative;
  & img {
    max-width: 20px;
  }
`;

const IconWrapOverlay = styled(IconWrap)`
  position: absolute;
  top: 0;
  left: 0;
`;

const NavLinkWithPictureIcon = styled(NavLink)`
  ${IconWrapOverlay} {
    opacity: 0;
  }
  &.active {
    ${IconWrapOverlay} {
      opacity: 1;
    }
  }
`;

export const SanityNavMobileTab: FC<INavigationTabFragment> = ({
  tabIcon,
  tabIconActive,
  tabLink
}) => {
  const route = tabLink?.link?.locale || routes.base;
  const requiresExactMatch = route === routes.base;

  return (
    <NavLinkWithPictureIcon to={route} requiresExactMatch={requiresExactMatch}>
      <IconWrapBase>
        {tabIcon?.locale && <RawPicture image={tabIcon?.locale} alt="" />}
        <IconWrapOverlay>
          {tabIconActive?.locale && <RawPicture image={tabIconActive?.locale} alt="" />}
        </IconWrapOverlay>
      </IconWrapBase>
      <NavLinkText>{tabLink?.text?.locale}</NavLinkText>
    </NavLinkWithPictureIcon>
  );
};
